import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { certificateQuote } from "../../store/certificates/actions";
export var useCertificateQuote = function (trigger, title, quoteId, page, limit) {
    var _a = useState(true), enable = _a[0], setEnable = _a[1];
    var dispatch = useDispatch();
    var _b = useSelector(function (state) { return ({
        responseCertificateQuote: state.Certificates.responseCertificateQuote,
        errorCertificateQuote: state.Certificates.errorCertificateQuote,
        loadingCertificateQuote: state.Certificates.loadingCertificateQuote,
    }); }), responseCertificateQuote = _b.responseCertificateQuote, errorCertificateQuote = _b.errorCertificateQuote, loadingCertificateQuote = _b.loadingCertificateQuote;
    useEffect(function () {
        if (trigger) {
            dispatch(certificateQuote({
                title: title,
                enable: enable,
                quoteId: quoteId,
                page: page,
                limit: limit,
            }));
        }
    }, [trigger, quoteId]);
    return {
        responseCertificateQuote: responseCertificateQuote,
        errorCertificateQuote: errorCertificateQuote,
        loadingCertificateQuote: loadingCertificateQuote,
        setEnable: setEnable,
    };
};
